
import './styles.scss'

const Flag = () => {
  return (
    <div className="panambi-flag text-label">GRATIS</div>
  );
};

export default Flag;